var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
                _c("i", { staticClass: "fas fa-redo-alt color-primary-1" }),
                _vm._v(" Devolución ")
              ]),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                attrs: {
                                  "class-container": "w-100",
                                  "custom-error-msg": "La fecha es requerida.",
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": new Date(),
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.model.returnDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "returnDate", $$v)
                                  },
                                  expression: "model.returnDate"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12 mt-2" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "custom-error-msg":
                                    "El comentario es requerido.",
                                  error: errors[0],
                                  label: "Comentario:",
                                  maxlength: 3000,
                                  rows: 4,
                                  "show-char-count": ""
                                },
                                model: {
                                  value: _vm.model.returnComment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "returnComment", $$v)
                                  },
                                  expression: "model.returnComment"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12 text-right mt-3 pt-1" },
                [
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-times-circle",
                      text: "Cancelar",
                      variant: "outline-danger mr-3"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("on-cancel")
                      }
                    }
                  }),
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-save",
                      text: "Guardar",
                      variant: "success"
                    },
                    on: {
                      click: function($event) {
                        return handleSubmit(_vm.submit)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }